import { render } from "./ChoseCategoryButton.vue?vue&type=template&id=68ae7ae7&scoped=true"
import script from "./ChoseCategoryButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ChoseCategoryButton.vue?vue&type=script&setup=true&lang=js"

import "./ChoseCategoryButton.vue?vue&type=style&index=0&id=68ae7ae7&scoped=true&lang=css"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68ae7ae7"],['__file',"resources/js/modules/product-categorization-drag-drop/components/filter/ChoseCategoryButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "68ae7ae7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('68ae7ae7', __exports__)) {
    api.reload('68ae7ae7', __exports__)
  }
  
  module.hot.accept("./ChoseCategoryButton.vue?vue&type=template&id=68ae7ae7&scoped=true", () => {
    api.rerender('68ae7ae7', render)
  })

}


export default __exports__